import { FiChevronDown, FiUser } from "react-icons/fi";
import { toUpper } from "lodash";
import classnames from "classnames";
import React from "react";

interface UserIconProps {
  userName?: string;
  rotatedChevron?: boolean;
  showNavAvatar?: boolean;
}

export const UserIcon = ({
  userName,
  rotatedChevron,
  showNavAvatar = true,
}: UserIconProps) => {
  return (
    <div className="user-nav">
      {showNavAvatar && (
        <div className="nav-avatar">
          <div className="circle">
            <span className="icon">
              <FiUser stroke="#FFFFFF" size={16} />
            </span>
          </div>
        </div>
      )}

      <div className="nav-details">
        <p className="nav-name">{toUpper(userName)}</p>
      </div>
      <FiChevronDown
        fill="#30374e"
        color="#30374e"
        stroke="#FFFFFF"
        size={14}
        className={classnames(`nav-chevron  ${rotatedChevron ? "rotate" : ""}`)}
      />
    </div>
  );
};

export default UserIcon;
